import { inject, Inject, Injectable, signal } from '@angular/core';
import { GraphqlClientService } from '@zen/core/services/graphql-client.service';
import { BehaviorSubject, Observable } from 'rxjs';  
import { studioInterceptor } from 'apps/studio/src/app/studio.interceptor';
import { GET_CURRENT_USER } from '../query/user.query';
import { EnvService } from '@zb/services/src/services/env.service';
@Injectable({
  providedIn: 'root'
})
export class EngineCommonService { 
  editorMode = signal<'normal' | 'QAStore' | 'QATheme'>('normal');
  /**
   * Variable used to identify the current store Id
   */
  currentStoreId = new BehaviorSubject<string>('');//906dbbc3-b954-4a6f-bcf4-1098788fa074
  /**
  * Service constructor which is used to inject the required services.
  * @param graphqlClientService To access methods inside GraphqlClientService.
  */
 constructor(
   private graphqlClientService: GraphqlClientService,
   private studioInterceptor :studioInterceptor,
   private envService :EnvService
  ) {
  }
  /**getCurrentUser
   * Retrieves all details for get One theme.
   * @param data to have data for the GraphQL query.
   * @returns containing the result of the GraphQL query.
   */
  getCurrentUser(data?: any): Observable<any> {
    this.graphqlClientService.updateApolloGraphqlUrl( this.envService?.getEnvironment()?.graphqlUri,this.studioInterceptor,true)
    return this.graphqlClientService.executeQuery(GET_CURRENT_USER, data ) as Observable<any>
  } 
}
